export const myMixin = {
	data(){
		return{
			logoSrc:require(`@/assets/images/dark/logo.png`)
		}
	},
	computed:{
		...Vuex.mapState('breadcrumb', ['skinPeeler','chartsColor']),
	},
	watch: {
		logoSrc: {
		  handler(newValue, oldValue) {
			this.logoSrc = newValue;
			this.$forceUpdate();
		  },
		  deep: true
		}
	},
	created(){
		this.switchStatus()
	},
	methods:{
		switchStatus(){
			if (!window.location.pathname.contain('visualization')) {
				document.documentElement.setAttribute(
				  "data-theme",
				  this.skinPeeler.status ? "light" : "dark",
				);
				this.chartsColor.color = this.skinPeeler.status ?'#FFFFFF':'#333333';
				this.logoSrc = this.skinPeeler.status ? require(`@/assets/images/dark/logo.png`):require(`@/assets/images/dark/lightLogo.png`);
			}else{
				document.documentElement.setAttribute(
				  "data-theme",
				  "light"
				);
				this.chartsColor.color = '#FFFFFF';
				this.logoSrc = require(`@/assets/images/dark/logo.png`);
			}
			this.$forceUpdate();
		},
	}
}